"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'db.operation.create': 'Create',
    'db.operation.update': 'Update',
    'db.operation.delete': 'Delete',
    'db.operation.upsert': 'Upsert',
    'db.operation.createMany': 'Create Many',
    'db.operation.updateMany': 'Update Many',
    'db.operation.deleteMany': 'Delete Many',
    'db.operation.findFirst': 'Find First',
    'db.operation.findMany': 'Find Many',
    'db.operation.findUnique': 'Find Unique',
    'db.operation.count': 'Count',
    'db.operation.aggregate': 'Aggregate',
    'db.operation.groupBy': 'Group By',
};
